// Platypus stickers, cut from the sheets in docs/ (transparent WebP in src/web/public/stickers).
// Shared so the server can validate a habit's sticker.

export type StickerSet = 'classic' | 'everyday' | 'chair' | 'world';

export interface Sticker {
  id: string;
  set: StickerSet;
  /** German description, usable as alt text. */
  label: string;
}

export const STICKERS: readonly Sticker[] = [
  { id: 'wave', set: 'classic', label: 'Winkt fröhlich' },
  { id: 'heart-hug', set: 'classic', label: 'Umarmt ein Herz' },
  { id: 'puzzled', set: 'classic', label: 'Grübelt' },
  { id: 'cheer', set: 'classic', label: 'Jubelt' },
  { id: 'swim', set: 'classic', label: 'Treibt im Wasser' },
  { id: 'reading', set: 'classic', label: 'Liest „Gute Ideen“' },
  { id: 'sleeping', set: 'classic', label: 'Schläft' },
  { id: 'hiking', set: 'classic', label: 'Wandert' },
  { id: 'coffee', set: 'classic', label: 'Erst mal Kaffee' },
  { id: 'king', set: 'classic', label: 'Trägt eine Krone' },
  { id: 'crying', set: 'classic', label: 'Ist traurig' },
  { id: 'snorkel', set: 'classic', label: 'Schnorchelt' },
  { id: 'wink', set: 'classic', label: 'Zwinkert' },
  { id: 'chess', set: 'classic', label: 'Spielt Schach' },
  { id: 'cozy', set: 'classic', label: 'Kuschelt mit einem Glas Wasser' },

  { id: 'laughing', set: 'everyday', label: 'Lacht laut' },
  { id: 'thumbs-up', set: 'everyday', label: 'Daumen hoch' },
  { id: 'cat-hug', set: 'everyday', label: 'Kuschelt mit einer Katze' },
  { id: 'sheep-hug', set: 'everyday', label: 'Kuschelt mit einem Schaf' },
  { id: 'weightlifting', set: 'everyday', label: 'Stemmt Gewichte' },
  { id: 'music', set: 'everyday', label: 'Hört Musik' },
  { id: 'hiking-mountains', set: 'everyday', label: 'Wandert in den Bergen' },
  { id: 'painting', set: 'everyday', label: 'Malt' },
  { id: 'detective', set: 'everyday', label: 'Ermittelt mit Lupe' },
  { id: 'reading-glasses', set: 'everyday', label: 'Liest mit Brille' },
  { id: 'sleeping-teddy', set: 'everyday', label: 'Schläft mit Teddy' },
  { id: 'bubble-bath', set: 'everyday', label: 'Nimmt ein Schaumbad' },
  { id: 'you-can-do-it', set: 'everyday', label: 'Du schaffst das!' },
  { id: 'heart', set: 'everyday', label: 'Hält ein Herz' },
  { id: 'coffee-happy', set: 'everyday', label: 'Kaffee macht Schnabeltiere glücklich' },
  { id: 'beach', set: 'everyday', label: 'Entspannt am Strand' },

  { id: 'chair-happy', set: 'chair', label: 'Stuhlgymnastik macht glücklich!' },
  { id: 'chair-stretch', set: 'chair', label: 'Locker bleiben!' },
  { id: 'chair-leg-raise', set: 'chair', label: 'Kleine Bewegung – große Wirkung!' },
  { id: 'chair-arms-wide', set: 'chair', label: 'Schultern auf und los!' },
  { id: 'chair-knee-lift', set: 'chair', label: 'Immer einen Schritt aktiver!' },
  { id: 'chair-twist', set: 'chair', label: 'Drehen lockert!' },
  { id: 'chair-strong-legs', set: 'chair', label: 'Starke Beine – auch im Sitzen!' },
  { id: 'chair-breathe', set: 'chair', label: 'Tief durchatmen – weiter geht’s!' },
  { id: 'chair-thumbs-up', set: 'chair', label: 'Du tust dir gut!' },
  { id: 'motto-heart', set: 'chair', label: 'Bewegung bringt Lebensfreude – in jedem Alter!' },

  { id: 'hello-france', set: 'world', label: 'Bonjour! – Frankreich' },
  { id: 'hello-italy', set: 'world', label: 'Ciao! – Italien' },
  { id: 'hello-netherlands', set: 'world', label: 'Hallo! – Niederlande' },
  { id: 'hello-england', set: 'world', label: 'Good Day! – England' },
  { id: 'hello-poland', set: 'world', label: 'Cześć! – Polen' },
  { id: 'hello-spain', set: 'world', label: '¡Hola! – Spanien' },
  { id: 'hello-sweden', set: 'world', label: 'Hej! – Schweden' },
  { id: 'hello-bavaria', set: 'world', label: 'Servus! – Bayern' },
  { id: 'hello-usa', set: 'world', label: 'Hi there! – USA' },
  { id: 'hello-japan', set: 'world', label: 'Konnichiwa! – Japan' },
  { id: 'coding', set: 'world', label: 'Programmiert: Kleine Schritte, große Ideen!' },
];

const IDS = new Set(STICKERS.map((s) => s.id));
export const isStickerId = (value: unknown): value is string => typeof value === 'string' && IDS.has(value);
